import { render, staticRenderFns } from "./SyllabusesStudentsList.vue?vue&type=template&id=78b7859f&scoped=true"
import script from "./SyllabusesStudentsList.vue?vue&type=script&lang=js"
export * from "./SyllabusesStudentsList.vue?vue&type=script&lang=js"
import style0 from "./SyllabusesStudentsList.vue?vue&type=style&index=0&id=78b7859f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b7859f",
  null
  
)

export default component.exports